var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.707,
    height: 35.085,
    viewBox: "0 0 94.707 35.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8",
    transform: "translate(-6 -8.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(-3028 -2544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M3034,2567.194v5.545l14.786-14.786v-5.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M3034,2567.194v5.545l14.786-14.786v-5.876Z",
    transform: "translate(0 14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M3034,2567.194v5.545l14.786-14.786v-5.876Z",
    transform: "translate(6.5 0.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M3034,2567.194v5.545l14.786-14.786v-5.876Z",
    transform: "translate(6.5 14.423)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M3062.841,2573.729l7.217-18.564,7.132,18.564",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M3065.044,2568.306h10.013",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M3084.094,2555.165v18.05h9.137",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M3095.751,2555.165h12.861",
    transform: "translate(-3028 -2543.265)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M3102.181,2555.9v17.755",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M3115.106,2555.9v18.262",
    transform: "translate(-3028 -2544.492)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M3115.106,2564.19h12.178",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M3115.106,2555.9v18.262",
    transform: "translate(-3016 -2544.492)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M3062.841,2577v5.853h2.647",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    transform: "translate(38.25 33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M3062.841,2561l2.3-5.95,2.214,5.95",
    transform: "translate(-3017.341 -2522)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M3065.044,2568.306h3.147",
    transform: "translate(-3018.852 -2531.01)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M3080.026,2583v-5.989l3.743,5.989v-5.989",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M2.357.083A2.474,2.474,0,0,1,1.241-.133a3.326,3.326,0,0,1-.9-.658A.218.218,0,0,1,.308-.837.16.16,0,0,1,.292-.916.189.189,0,0,1,.35-1.045a.17.17,0,0,1,.125-.062.191.191,0,0,1,.142.075A2.237,2.237,0,0,0,1.4-.45a2.245,2.245,0,0,0,.929.2,1.973,1.973,0,0,0,.758-.137,1.224,1.224,0,0,0,.525-.392.962.962,0,0,0,.192-.6,1.035,1.035,0,0,0-.233-.683,1.733,1.733,0,0,0-.579-.425q-.354-.167-.746-.308-.308-.117-.608-.242a2.553,2.553,0,0,1-.541-.3,1.305,1.305,0,0,1-.383-.45,1.435,1.435,0,0,1-.142-.671,1.294,1.294,0,0,1,.221-.737,1.529,1.529,0,0,1,.633-.525,2.263,2.263,0,0,1,.979-.2,2.585,2.585,0,0,1,.925.171,1.553,1.553,0,0,1,.708.512.362.362,0,0,1,.083.175.164.164,0,0,1-.062.117.2.2,0,0,1-.137.058.134.134,0,0,1-.108-.05,1.534,1.534,0,0,0-.362-.346A1.69,1.69,0,0,0,2.965-5.5,1.981,1.981,0,0,0,2.4-5.581a1.98,1.98,0,0,0-.741.133,1.287,1.287,0,0,0-.533.379.926.926,0,0,0-.2.6.905.905,0,0,0,.221.629,1.76,1.76,0,0,0,.562.408q.342.162.7.3.317.108.629.237a2.559,2.559,0,0,1,.566.321,1.4,1.4,0,0,1,.4.483,1.6,1.6,0,0,1,.15.733,1.234,1.234,0,0,1-.221.708,1.589,1.589,0,0,1-.621.525A2.2,2.2,0,0,1,2.357.083Z",
    transform: "translate(60 38.93)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M3096.913,2577.165h-3.123v5.7h3.123",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M3093.79,2580.083h3.123",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M1.037,0A.171.171,0,0,1,.9-.051a.172.172,0,0,1-.047-.12V-5.828a.164.164,0,0,1,.051-.12A.164.164,0,0,1,1.028-6H3.291a1.872,1.872,0,0,1,.887.2,1.5,1.5,0,0,1,.6.553,1.5,1.5,0,0,1,.214.8,1.728,1.728,0,0,1-.141.711,1.431,1.431,0,0,1-.394.527,1.584,1.584,0,0,1-.578.3l-.394-.069a1.3,1.3,0,0,1,.651.176,1.366,1.366,0,0,1,.506.514,1.618,1.618,0,0,1,.2.827,3.949,3.949,0,0,0,.039.638.939.939,0,0,0,.1.321.552.552,0,0,0,.15.163A.221.221,0,0,1,5.2-.249a.17.17,0,0,1,.009.12.167.167,0,0,1-.056.081.194.194,0,0,1-.081.039.146.146,0,0,1-.094-.017.9.9,0,0,1-.236-.206,1.109,1.109,0,0,1-.193-.42,3.232,3.232,0,0,1-.077-.806A1.406,1.406,0,0,0,4.349-2.1a.962.962,0,0,0-.317-.369,1.127,1.127,0,0,0-.411-.171,2.086,2.086,0,0,0-.4-.043H1.14l.077-.1V-.171a.164.164,0,0,1-.051.12A.174.174,0,0,1,1.037,0Zm.094-3.025h2.2a1.537,1.537,0,0,0,.634-.206,1.344,1.344,0,0,0,.476-.48,1.394,1.394,0,0,0,.184-.728,1.139,1.139,0,0,0-.373-.87,1.419,1.419,0,0,0-1.007-.347H1.174l.043-.06v2.785Z",
    transform: "translate(70 39)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M3104.146,2577l2.117,5.722,2.158-5.722",
    transform: "translate(-3028 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M3110.446,2577.165v6",
    transform: "translate(-3028 -2544.165)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M5.142-5.341a.17.17,0,0,1,.075.112.193.193,0,0,1-.033.129.136.136,0,0,1-.1.062.211.211,0,0,1-.121-.029A3.111,3.111,0,0,0,4.2-5.45a2.684,2.684,0,0,0-.878-.141,2.523,2.523,0,0,0-.994.2,2.468,2.468,0,0,0-.811.553,2.6,2.6,0,0,0-.549.849,2.845,2.845,0,0,0-.2,1.082,2.845,2.845,0,0,0,.2,1.082,2.6,2.6,0,0,0,.549.849,2.468,2.468,0,0,0,.811.553,2.523,2.523,0,0,0,.994.2,2.647,2.647,0,0,0,.874-.141A3.321,3.321,0,0,0,4.95-.749a.172.172,0,0,1,.125-.033.152.152,0,0,1,.108.067.172.172,0,0,1,.033.125.152.152,0,0,1-.067.108,2.869,2.869,0,0,1-.5.275A3.66,3.66,0,0,1,4,0,3.014,3.014,0,0,1,3.32.083,2.821,2.821,0,0,1,2.2-.141,2.887,2.887,0,0,1,1.273-.77a2.965,2.965,0,0,1-.628-.948A3.054,3.054,0,0,1,.416-2.912,3.054,3.054,0,0,1,.645-4.106a2.965,2.965,0,0,1,.628-.948A2.887,2.887,0,0,1,2.2-5.683,2.821,2.821,0,0,1,3.32-5.907a3.2,3.2,0,0,1,.978.15A3.036,3.036,0,0,1,5.142-5.341Z",
    transform: "translate(84 38.93)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M3096.913,2577.165h-3.123v5.705h3.123",
    transform: "translate(-3002 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M3093.79,2580.083h3.123",
    transform: "translate(-3002 -2544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M2.357.083A2.474,2.474,0,0,1,1.241-.133a3.326,3.326,0,0,1-.9-.658A.218.218,0,0,1,.308-.837.16.16,0,0,1,.292-.916.189.189,0,0,1,.35-1.045a.17.17,0,0,1,.125-.062.191.191,0,0,1,.142.075A2.237,2.237,0,0,0,1.4-.45a2.245,2.245,0,0,0,.929.2,1.973,1.973,0,0,0,.758-.137,1.224,1.224,0,0,0,.525-.392.962.962,0,0,0,.192-.6,1.035,1.035,0,0,0-.233-.683,1.733,1.733,0,0,0-.579-.425q-.354-.167-.746-.308-.308-.117-.608-.242a2.553,2.553,0,0,1-.541-.3,1.305,1.305,0,0,1-.383-.45,1.435,1.435,0,0,1-.142-.671,1.294,1.294,0,0,1,.221-.737,1.529,1.529,0,0,1,.633-.525,2.263,2.263,0,0,1,.979-.2,2.585,2.585,0,0,1,.925.171,1.553,1.553,0,0,1,.708.512.362.362,0,0,1,.083.175.164.164,0,0,1-.062.117.2.2,0,0,1-.137.058.134.134,0,0,1-.108-.05,1.534,1.534,0,0,0-.362-.346A1.69,1.69,0,0,0,2.965-5.5,1.981,1.981,0,0,0,2.4-5.581a1.98,1.98,0,0,0-.741.133,1.287,1.287,0,0,0-.533.379.926.926,0,0,0-.2.6.905.905,0,0,0,.221.629,1.76,1.76,0,0,0,.562.408q.342.162.7.3.317.108.629.237a2.559,2.559,0,0,1,.566.321,1.4,1.4,0,0,1,.4.483,1.6,1.6,0,0,1,.15.733,1.234,1.234,0,0,1-.221.708,1.589,1.589,0,0,1-.621.525A2.2,2.2,0,0,1,2.357.083Z",
    transform: "translate(96.5 38.93)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlthLogo);
export default __webpack_public_path__ + "static/media/ALTHLogo.9149a6b1e892dfc2e4a7ddabd58bc2ee.svg";
export { ForwardRef as ReactComponent };